import * as Yup from 'yup';

const HybridEventSchema = Yup.object({
    type: Yup.string(),
    attend_dinner: Yup.boolean(),
    food_preference: Yup.string().nullable(),
});

export { HybridEventSchema };
